import { Variant } from '@mui/material/styles/createTypography';
import { useState, useEffect } from 'react';

import { REQUIRED_INDICATOR } from 'theSource/utils';
import {
  GreyedOutValueStyled,
  LabelStyled,
  LabelValuePairWrapperStyled,
  ValueStyled,
} from './LabelValuePairStyled';
import { PsButtonTuner } from 'stencilSetup';

export interface LabelValuePairProps {
  greyedOutValue?: boolean;
  label: string;
  required?: boolean;
  value: string | JSX.Element;
  valueHolderVariant?: Variant;
}

export const LabelValuePair = ({
  greyedOutValue,
  label,
  required,
  value: propValue,
  valueHolderVariant = 'body1',
}: LabelValuePairProps) => {
  const ValueHolder = greyedOutValue ? GreyedOutValueStyled : ValueStyled;

  const [hideValue, setHideValue] = useState(true);
  const [fieldValue, setFieldValue] = useState(propValue);

  useEffect(() => {
    setFieldValue(propValue);
  }, [propValue]);

  const isSsn = label === 'SSN';

  let value = fieldValue;
  if (hideValue && isSsn) {
    const stringValue = value as string;
    value = stringValue.replace(/[0-9X]/g, '*');
  }

  const toggleHide = () => {
    setHideValue(!hideValue);
  };

  return (
    <LabelValuePairWrapperStyled data-testid="label-value-pair">
      <LabelStyled variant="label" component="p">
        {label}
        {required && REQUIRED_INDICATOR}
      </LabelStyled>
      <ValueHolder variant={valueHolderVariant} component="p">
        {value}
        &nbsp;
        {isSsn && (
          <PsButtonTuner
            data-test-id="toggle-display-ssn"
            buttonId="toggle-display-ssn"
            label={hideValue ? 'Show SSN' : 'Hide SSN'}
            level="tertiary"
            extraClass="mt-n2"
            onClick={toggleHide}
            otherData={[
              { attribute: 'aria-describedby', value: 'subscriber-name' },
            ]}
          />
        )}
      </ValueHolder>
    </LabelValuePairWrapperStyled>
  );
};
